import { Control as ControlType, SmartQuestionStatus } from '@/gen/inventory/v1/control_service_pb'

import { ControlTimelineTab } from '@/pages/control/consts'

const hasUnviewedComments = (control: ControlType): boolean => {
  const smartQuestion = control.smartQuestion
  if (!smartQuestion || smartQuestion.commentCount <= 0) return false
  return !smartQuestion.commentsViewed
}

// The tab the control drawer should open on.
export const getPreferredControlDrawerTab = (control: ControlType): string =>
  control.smartQuestion?.status === SmartQuestionStatus.AWAITING_REVIEW ||
  hasUnviewedComments(control)
    ? ControlTimelineTab.ACTIVITY
    : ControlTimelineTab.OVERVIEW
